import _extends from 'babel-runtime/helpers/extends';
import { jsonResponse } from 'fetch-utilities';

var PENDING = "store/categories/PENDING";
var LOADING = "store/categories/LOADING";
var LOADED = "store/categories/LOADED";

var initialState = {
  state: PENDING,
  data: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOADING:
      return _extends({}, state, {
        state: action.type
      });

    case LOADED:
      return _extends({}, state, {
        state: action.error ? state.state : action.type,
        data: action.error ? state.data : action.payload,
        error: action.error ? action.payload : null
      });

    default:
      return state;
  }
}

var loadAll = function loadAll() {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING
    });

    dispatch({
      type: LOADED,
      payload: client("/categories").then(jsonResponse)
    });
  };
};

var load = function load() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "?parentId=ROOT&includeInMenu=true";
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING
    });

    dispatch({
      type: LOADED,
      payload: client("/categories" + params).then(jsonResponse)
    });
  };
};

export { PENDING, LOADING, LOADED, loadAll, load };
export default reducer;
